import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Collapse, Checkbox } from 'antd';

import {
    selectorGrupsVariables,
    selectorVariables,
    selectorVariablesMoments } from '../../selectors/selector_estacio_formulari_estructura';

import { estacioIntroduccioVariablesModificarVariableMoment } from '../../actions/estacio';

const Panel = Collapse.Panel;

class EstacioIntroduccioVariables extends Component {

    estaCheckboxMarcat(idVariableMoment) {

        return this.props.dades.includes(idVariableMoment);
    }

    modificarCheckbox(idVariableMoment, estaCheckboxMarcat) {
        this.props.estacioIntroduccioVariablesModificarVariableMoment(idVariableMoment, estaCheckboxMarcat);
    }

    renderitzarGrupVariables(grup) {
        const { variables } = this.props;

        return grup.idVariables.map(idVariable => {
            const variable = variables[idVariable];
            const variablesMomentsRenderitzats = this.renderitzarVariablesMoments(variable.idVariablesMoments);

            return (
                <div className='estacio-variables' key={idVariable}>
                    {variable.nom}
                    {variablesMomentsRenderitzats}
                </div>
            );
        });
    }

    renderitzarVariablesMoments(idVariablesMoments) {

        const { variablesMoments } = this.props;

        return idVariablesMoments.map(idVariableMoment => {
            const nomMoment = variablesMoments[idVariableMoment];
            return (
                <div key={idVariableMoment}>
                    <Checkbox
                        disabled={!this.props.editable}
                        checked={this.estaCheckboxMarcat(idVariableMoment)}
                        onChange={(e) => this.modificarCheckbox(idVariableMoment, e.target.checked)}
                    >
                        {nomMoment}
                    </Checkbox>
                </div>
            );
        });

    }

    render() {
        const { grupsVariables,dades } = this.props;

        if(!dades || typeof dades === 'undefined') return <div></div>;

        const idsGrups = Object.keys(grupsVariables);
        const idsGrupsOrdenats = idsGrups.sort((idGrupA, idGrupB) => grupsVariables[idGrupA].ordre - grupsVariables[idGrupB].ordre);

        const grupsVariablesRenderitzats = idsGrupsOrdenats.map(idGrup => {
            const grup = grupsVariables[idGrup];
            return (
                <Panel header={grup.nom} key={idGrup}>
                    {this.renderitzarGrupVariables(grup)}
                </Panel>
            );
        });

        return (
            <Collapse bordered={false}>
                {grupsVariablesRenderitzats}
            </Collapse>
        );
    }
}

EstacioIntroduccioVariables.propTypes = {
    grupsVariables: PropTypes.object,
    variables: PropTypes.object,
    variablesMoments: PropTypes.object,
    dades: PropTypes.array,
    editable: PropTypes.bool,
    estacioIntroduccioVariablesModificarVariableMoment: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        grupsVariables: selectorGrupsVariables(state),
        variables: selectorVariables(state),
        variablesMoments: selectorVariablesMoments(state),
    };
};

export default connect(mapStateToProps, {estacioIntroduccioVariablesModificarVariableMoment})(EstacioIntroduccioVariables);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioVariables.js